import { LocationAddressFragment, RetailerNetworkLocationGroupFragment } from '@occc/graphql';

import { GeneralDetailsCard } from './general-details-card.component';

import { useGetRetailerNetworkLocationGroups } from '../../../data-access/queries';

type GeneralDetailsContainerProps = {
  retailerNetworkUuid: string;
  locationUuid: string;
  address?: LocationAddressFragment | null;
  phoneNumbers: string[];
};

export const GeneralDetailsContainer = ({
  retailerNetworkUuid,
  locationUuid,
  address,
  phoneNumbers,
}: GeneralDetailsContainerProps) => {
  const { data: locationGroups } = useGetRetailerNetworkLocationGroups({
    filter: {
      retailerNetworkUuidEquals: retailerNetworkUuid,
      retailerNetworkLocationUuidEquals: locationUuid,
    },
  });

  const locationGroupName = locationGroups
    ?.map((locationGroup: RetailerNetworkLocationGroupFragment) => locationGroup.name)
    .join(', ');

  return (
    <GeneralDetailsCard
      address={address}
      phoneNumbers={phoneNumbers}
      locationGroupName={locationGroupName}
    />
  );
};
